module.exports = __webpack_public_path__ + "img/symbol_3.73298a77.png";